<template>
  <div>
    <a-card title="任务创建">
      <a-spin :spinning="loading">
        <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
          <a-row>
            <a-col :span="8" style="width: 340px;">
              <a-form-model-item prop="task_id" label="任务编号">
                <a-input v-model="form.task_id" :disabled="true"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="8" style="width: 340px;">
              <a-form-model-item prop="start_date" label="任务开始日期">
                <a-date-picker v-model="form.start_date" valueFormat="YYYY-MM-DD" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" style="width: 340px;">
              <a-form-model-item prop="end_date" label="任务结束日期">
                <a-date-picker v-model="form.end_date" valueFormat="YYYY-MM-DD" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="6" style="width: 340px;">
              <a-form-model-item prop="supplier" label="所在省">
                <a-select v-model="now_city.province" style="width: 100%" >
                  <a-select-option v-for="item in province_Items" :key="item" :value="item">
                    {{ item }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8" style="width: 340px;">
              <a-form-model-item prop="warehouse" label="所在市">
                <a-select v-model="now_city.city" style="width: 100%" >
                  <a-select-option v-for="item in city_Items" :key="item" :value="item">
                    {{ item}}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8" style="width: 340px;">
              <a-form-model-item prop="handler" label="所在区/县">
                <a-select v-model="now_city.district" style="width: 100%" >
                  <a-select-option v-for="item in distirct_Items" :key="item" :value="item">
                    {{ item}}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>

          </a-row>
        </a-form-model>

        <a-divider orientation="left">详细信息</a-divider>

        <div>

          <div style="margin-top: 16px;">
            <a-table rowKey="name" size="middle" :columns="columns" :data-source="data_end" >
              <div slot="image" slot-scope="value, item, index">
                <div :key="it" v-for="(it,ind) in value" style="display: flex;flex-direction: column;">
                  <img :src="it" style="width: 200px;height: 150px;margin-top: 10px;"/>
                </div>

              </div>
              <div slot="action" slot-scope="value, item, index">
                <a-button-group v-if="!item.isTotal" size="small">
                  <a-button type="primary" @click="look(item)" size="large">查看检测情况</a-button>
                </a-button-group>
              </div>
              <div slot="map_data" slot-scope="value, item, index">
                <Map :data="item"></Map>
              </div>

              <div slot="result" slot-scope="value, item, index">
                <div v-for="(it,ind) in value" :key="ind" style="font-size: 15px;">
                  <div style="height: 150px;display: flex;flex-direction: column;justify-content: center;align-items: center">
                    <a v-if="it" style="color: red;font-weight: 1000;">裂纹</a>
                    <a v-else>正常</a>
                  </div>

                </div>
              </div>
            </a-table>
          </div>
        </div>

        <a-divider orientation="left">任务信息</a-divider>

        <div>
          <a-row :gutter="16">
            <a-col :span="4">
              <a-form-model-item
                  prop="other_amount"
                  label="备注"
                  :label-col="{ span: 24 }"
                  :wrapper-col="{ span: 24 }"
              >
                <a-input v-model="form.beizhu" :disabled="true" />
              </a-form-model-item>
            </a-col>
            <a-col :span="4">
              <a-form-model-item label="发布者" :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }">
                <a-input   v-model="form.person" :disabled="true"   style="width: 100%;" />
              </a-form-model-item>
            </a-col>
            <a-col :span="4">
              <a-form-model-item label="是否完成" :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }">
                <a-input v-model="form.is_finish" :disabled="true" style="width: 100%;" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
      </a-spin>

    </a-card>
    <image_detail
        v-model="visible"
        :data="detail_data"
    />
  </div>
</template>

<script>

import axios from "axios";
export default {
  components: {
    image_detail:()=> import("@/views/task/image_detail"),
    Map:()=> import("@/components/map/map")
  },
  data() {
    return {
      is_change_city:false,
      now_city:{},
      now_position:{},
      userlist:[{username:'admin',id:0},{username:'谭福华',id:2},{username:'齐辛格',id:3}],
      description: "新增",
      province_Items: [],
      city_Items: [],
      distirct_Items: [],
      accountsItems: [],
      add_task: false,
      add_task_form:{
        cnt:5,
        person:'',
        name:'',
        beizhu:'',
        all_marker:[],
        all_line:[]

      },
      data_end:[{
        name:'',
        person:'',
        task_id:'',
        all_distance:'',
        all_line:'',
        all_marker:'',
        cnt:'',
        image:[],
        result_image:[],
      }],
      loading: false,
      model: {},
      form: {},
      rules: {
        start_date: [{ required: true, message: "请输入开始日期", trigger: "change" }],
        end_date: [{ required: true, message: "请选择结束日期", trigger: "change" }],
        task_id: [{ required: true, message: "请选择任务编号", trigger: "change" }],

      },
      columns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          width: 45,
          customRender: (value, item, index) => {
            return item.isTotal ? "合计" : index + 1;
          },
        },
        {
          title: "检测范围",
          dataIndex: "map_data",
          key: "map_data",
          width: 200,
          scopedSlots: { customRender: "map_data" },
        },
        {
          title: "拍照次数",
          dataIndex: "cnt",
          key: "cnt",
          width: 80
        },

        {
          title: "上传图片",
          dataIndex: "image",
          key: "image",
          width: 200,
          scopedSlots: { customRender: "image" }
        },
        {
          title: "检测图片",
          dataIndex: "result_image",
          key: "result_image",
          width: 200,
          scopedSlots: { customRender: "image" }
        },
        {
          title: "检测算法",
          dataIndex: "person",
          key: "person",
          width: 60,
        },
      ],
      form_data:[],
      detail_data:{},
      visible:false,
      url:""
    };
  },
  methods: {
    init_data(){
      const data = this.$route.params;
      //对最终结果进行初始化
      this.form = {...data.form};
      this.now_city = {...data.now_city};
      this.form_data = [...data.task];
      console.log(this.form_data)
      this.data_end[0].image = this.form_data[0].photo;
      this.data_end[0].all_distance = this.form_data[0].all_distance
      this.data_end[0].all_line = this.form_data[0].all_line
      this.data_end[0].all_marker = this.form_data[0].all_marker
      this.data_end[0].task_id=this.form_data[0].task_id
      console.log(666666)
      console.log(this.data_end[0].map_data)
      this.data_end[0].cnt = this.form_data[0].photo.length
      this.data_end[0].person = "YoloV9"
      console.log(this.form_data[0].all_distance)
      console.log(this.data_end)

      console.log(this.form_data)
      console.log(this.form_data[0].photo)
    },

    initresult() {
      const axios = require('axios');
      const FormData = require('form-data');
      ///后端识别
      let photoArray = this.form_data[0].photo;
      let cleanedPhotoArray = photoArray.map(url => url.replace(/(^"|"$)/g, ''));
      this.form_data[0].photo = cleanedPhotoArray;
      console.log(10010101010101)
      console.log(this.form_data[0].photo)

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'http://127.0.0.1:8888/recognize?imageUrl='+this.form_data[0].photo+'&task_id='+this.form.task_id,
      };

      axios.request(config)
          .then((response) => {
            console.log(response.data);
            let dataArray = response.data;
            let resultphotoArray = dataArray.map(str => {
              // 去除问号及其后的内容
              let noQuestionMarkStr = str.replace(/\?.*/, '');

              // 去除开头的引号，如果存在的话
              let noLeadingQuoteStr = noQuestionMarkStr.replace(/^"/, '');

              // 去除末尾的换行符
              let finalStr = noLeadingQuoteStr.replace(/\n$/, '');

              return finalStr;
            });
            console.log(resultphotoArray);
            this.data_end[0].result_image = resultphotoArray;
            this.data_end[0]=[]

            console.log(1123301013003);
            console.log(this.data_end)
          })
          .catch((error) => {
            console.log(error);
          });
      ///////
    },
    openMaterialModal() {
      this.add_task = true;
    },
    look(e){
      console.log(e);
      this.detail_data = {
        image:[...e.image],
        result_image:[...e.result_image],
        result:[...e.result]
      };
      this.visible=true;
    }

  },
  mounted() {
    this.init_data();
    this.initresult()
  },
};
</script>
